import React, {Component} from 'react';
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom';
import Storage from '../services/Storage'

export function withAuthorization(Comp, roles) {

  class Authentication extends Component {
    render() {

      const user = Storage.getItem('user');
      return (
        user && roles.includes(user.role) ?
          <Comp
            {...this.props}/>
          : <span>You are not authorized to view this page</span>
      )
    }
  }

  return withRouter(connect()(Authentication));

}

export default withAuthorization;


export function withAuthorizationV2(Comp, roles) {
  function Authentication(props) {
    const user = Storage.getItem('user');

    if (!user || !roles.includes(user.role)) {
      return <span>You are not authorized to view this page</span>
    }
    return <Comp {...props}/>
  }

  return withRouter(connect()(Authentication));
}
